import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';


@Component({
  selector: 'mega-store-factory-generate-barcode',
  templateUrl: './generate-barcode.component.html',
  styleUrls: ['./generate-barcode.component.scss']
})
export class GenerateBarcodeComponent {
  constructor(
    public dialogRef: MatDialogRef<GenerateBarcodeComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {

  }

  closeDialog(): void {
    this.dialogRef.close({ 
      message: 'Batch added!' }); // Send data back
  }
}
